import { render, staticRenderFns } from "./back_doc.vue?vue&type=template&id=3f872e0c&scoped=true"
import script from "./back_doc.vue?vue&type=script&lang=js"
export * from "./back_doc.vue?vue&type=script&lang=js"
import style0 from "./back_doc.vue?vue&type=style&index=0&id=3f872e0c&prod&lang=css"
import style1 from "./back_doc.vue?vue&type=style&index=1&id=3f872e0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f872e0c",
  null
  
)

export default component.exports